// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"52fe571f","48":"965c6434","136":"b543b3b0","160":"d078cdc2","177":"ebce4e48","305":"aab0a6d5","486":"fe9b6b54","749":"fd40c4c0","787":"7984f105","800":"900edf55","835":"46de9af0","980":"ad1e7396"}[chunkId] + ".chunk.js";
};